import { z } from 'zod';
/**
 * Dev module — TEMPORARY (WS-1). A scratch doc used by the `/dev/sync` page and the WS-8
 * torture suite to exercise concurrent editing, offline queue + replay and the sync status
 * indicator. Delete this module (and its web counterpart) once Phase 1 features exist.
 */
export const DEV_SCRATCH_DOC = 'dev:scratch';
/**
 * Doc shape (ROADMAP §1.3, the same split the real `list:<id>` docs use):
 *
 *   `itemsById` — Y.Map<itemId, Y.Map<field>>   the items themselves, one nested map each
 *   `itemOrder` — Y.Array<itemId>               order only, never content
 *
 * Storing whole item objects as Y.Array elements looks simpler but is not conflict-free:
 * an "update" then has to be a delete+insert, so two people editing one item concurrently
 * end up with two copies of it, and an edit racing a delete resurrects the item. Keys are
 * new (not `items`) so no existing scratch doc has a `Y.Array` under a name that is now a
 * `Y.Map`. (WS-8, 2026-07-28.)
 */
export const DEV_SCRATCH_ITEMS_KEY = 'itemsById';
/** Y.Array key holding item ids in display order. */
export const DEV_SCRATCH_ORDER_KEY = 'itemOrder';
export const devScratchItemSchema = z.object({
    id: z.string().min(1).max(64),
    text: z.string().max(2000),
    checked: z.boolean(),
    /** Client id string of the last writer — enough for "who touched this" in the scratch UI. */
    by: z.string().max(64),
    at: z.string(),
});
//# sourceMappingURL=index.js.map